import React from 'react';
import { Link } from 'react-router-dom';
import './OrderSuccessPage.css';

const OrderSuccessPage = () => {
  return (
    <div className="order-success-page">
      <div className="container">
        <div className="success-content">
          <div className="success-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" fill="#27ae60"/>
              <path d="m9 12 2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <h1>تم تأكيد طلبك بنجاح!</h1>
          <p>شكراً لك على طلبك. سنقوم بالتواصل معك قريباً لتأكيد التفاصيل وترتيب التسليم.</p>
          
          <div className="order-info">
            <h3>ماذا يحدث الآن؟</h3>
            <ul>
              <li>سنراجع طلبك ونتأكد من توفر الكتب</li>
              <li>سنتواصل معك خلال 24 ساعة لتأكيد التفاصيل</li>
              <li>سيتم تحضير طلبك وشحنه في أقرب وقت</li>
              <li>ستحصل على رقم تتبع للشحنة</li>
            </ul>
          </div>
          
          <div className="success-actions">
            <Link to="/books" className="btn btn-primary">
              تصفح المزيد من الكتب
            </Link>
            <Link to="/" className="btn btn-secondary">
              العودة للرئيسية
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessPage;
